import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey } from '../../utils/keys';
import { getNetworkKey } from '../../utils/keys/network.key';
export const useUpdateNewDomain = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.network.updateNewDomain(input), {
        onMutate: variables => {
            const authTokenKey = getAuthTokensKey();
            queryClient.setQueriesData(authTokenKey, old => ({
                ...old,
                network: {
                    ...old.network,
                    newDomain: variables.input.domain,
                },
            }));
        },
        onSettled: () => {
            const authTokenKey = getAuthTokensKey();
            const networkKey = getNetworkKey();
            queryClient.invalidateQueries(authTokenKey);
            queryClient.invalidateQueries(networkKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateNewDomain.js.map